export default "__VITE_ASSET__C27PIs1x__"